module.exports = __webpack_public_path__ + "img/119.93fed8ed.jpg";